// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2435":"e1c34bb7","5338":"ddeb9bce","6517":"9c4bec16"}[chunkId] + ".chunk.css";
};